// P3 · Highlight tooltip. Pinned popover for the active span: explanation + (when
// present) a NewsSense-style "see how another outlet put it" cross-outlet reveal.

import type { Bundle } from "../types";
import type { UIState } from "../state";
import { kindColor } from "../style";
import { SourceLink, type OpenSource } from "./SourceLink";

export function HighlightTooltip({ b, s, onClose, onRevealCross, onOpenSource }: {
  b: Bundle; s: UIState; onClose: () => void; onRevealCross: () => void; onOpenSource?: OpenSource;
}) {
  const hl = s.pinnedHl ? b.highlights.find((h) => h.id === s.pinnedHl) : null;
  if (!hl) return null;
  const c = kindColor(hl.kind);
  const hasCross = !!hl.cross_outlet;

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 50 }} />
      <div className="lenspop" style={{ position: "fixed", top: s.tipPos.top, left: s.tipPos.left, zIndex: 51, width: 340, maxWidth: "calc(100vw - 24px)", background: "#fff", borderRadius: 7, boxShadow: "0 14px 40px rgba(15,15,15,.16)", border: "1px solid rgba(55,53,47,.14)", borderTop: "3px solid " + c.line, padding: "13px 15px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 7 }}>
          <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: ".04em", textTransform: "uppercase", color: c.fg, background: c.bg, padding: "3px 8px", borderRadius: 4 }}>
            {hl.kind === "device" ? "◆ Loaded language" : "▲ Framing axis"}
          </span>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "rgba(55,53,47,.4)", fontSize: 16, cursor: "pointer", lineHeight: 1, padding: 0 }}>×</button>
        </div>
        <div style={{ fontFamily: "'Source Sans 3',serif", fontSize: 13, fontStyle: "italic", color: "#26241f", marginBottom: 7, lineHeight: 1.4 }}>"{hl.quote}"</div>
        <p style={{ margin: 0, fontSize: 12.5, lineHeight: 1.55, color: "rgba(55,53,47,.72)" }}>{hl.explanation}</p>
        {hasCross && (
          <div style={{ marginTop: 11, paddingTop: 11, borderTop: "1px solid rgba(55,53,47,.09)" }}>
            {!s.revealCross ? (
              <button onClick={onRevealCross} style={{ display: "flex", alignItems: "center", gap: 7, background: "#f7f6f3", border: "1px solid rgba(55,53,47,.12)", borderRadius: 5, padding: "8px 11px", width: "100%", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600, color: "#37352f" }}>
                ↔ See how another outlet put it
              </button>
            ) : (
              <div className="lensfade">
                <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: ".05em", color: "rgba(55,53,47,.4)", fontWeight: 600, marginBottom: 4 }}>
                  <SourceLink outlet={hl.cross_outlet!.alt_outlet} sources={b.sources}
                    meta={{ from: "cross_outlet", highlight_id: hl.id }} onOpen={onOpenSource} />
                </div>
                <div style={{ fontFamily: "'Source Sans 3',serif", fontSize: 13, fontStyle: "italic", lineHeight: 1.45, color: "#37352f" }}>"{hl.cross_outlet!.alt_text}"</div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
